import type { AvailableBushingsMapInterface } from './CrusherConeCHTypes';
import { CrusherTypes } from './CrusherConeCHTypes';

/**
 * Model CH950 is not migrated from old Plant Designer, Need to fix so that you can make two choices when throw is either 18 or 22
 */
export const AvailableBushings: AvailableBushingsMapInterface = {
  [CrusherTypes.CH420]: {
    concaves: {
      EC: {
        13: ['13 + 16 + 18'],
        16: ['13 + 16 + 18'],
        18: ['13 + 16 + 18', '18 + 20 + 22'],
        20: ['18 + 20 + 22'],
        22: ['18 + 20 + 22', '22 + 25'],
        25: ['22 + 25'],
      },
      C: {
        13: ['13 + 16 + 18'],
        16: ['13 + 16 + 18'],
        18: ['13 + 16 + 18', '18 + 20 + 22'],
        20: ['18 + 20 + 22'],
        22: ['18 + 20 + 22', '22 + 25'],
        25: ['22 + 25'],
      },
      Other: {
        13: ['13 + 16 + 18'],
        16: ['13 + 16 + 18'],
        18: ['13 + 16 + 18', '18 + 20 + 22'],
        20: ['18 + 20 + 22'],
        22: ['18 + 20 + 22', '22 + 25 + 28'],
        25: ['22 + 25 + 28'],
        28: ['22 + 25 + 28'],
      },
    },
  },
  [CrusherTypes.CH430]: {
    concaves: {
      EC: {
        16: ['16 + 19 + 22'],
        19: ['16 + 19 + 22'],
        22: ['16 + 19 + 22', '22 + 25 + 29'],
        25: ['22 + 25 + 29'],
        29: ['22 + 25 + 29', '29 + 32 + 34'],
        32: ['29 + 32 + 34'],
        34: ['29 + 32 + 34'],
      },
      C: {
        16: ['16 + 19 + 22'],
        19: ['16 + 19 + 22'],
        22: ['16 + 19 + 22', '22 + 25 + 29'],
        25: ['22 + 25 + 29'],
        29: ['22 + 25 + 29', '29 + 32 + 34'],
        32: ['29 + 32 + 34'],
        34: ['29 + 32 + 34'],
      },
      Other: {
        16: ['16 + 19 + 22'],
        19: ['16 + 19 + 22'],
        22: ['16 + 19 + 22', '22 + 25 + 29'],
        25: ['22 + 25 + 29'],
        29: ['22 + 25 + 29', '29 + 32 + 34 + 36'],
        32: ['29 + 32 + 34 + 36'],
        34: ['29 + 32 + 34 + 36'],
        36: ['29 + 32 + 34 + 36'],
      },
    },
  },
  [CrusherTypes.CH440]: {
    concaves: {
      Other: {
        16: ['16 + 20 + 24'],
        20: ['16 + 20 + 24'],
        24: ['16 + 20 + 24', '24 + 28 + 32'],
        28: ['24 + 28 + 32'],
        32: ['24 + 28 + 32', '32 + 36 + 40 + 44'],
        36: ['32 + 36 + 40 + 44'],
        40: ['32 + 36 + 40 + 44'],
        44: ['32 + 36 + 40 + 44'],
      },
    },
  },
  [CrusherTypes.CH442]: {
    concaves: {
      Other: {
        16: ['16 + 20 + 24'],
        20: ['16 + 20 + 24'],
        24: ['16 + 20 + 24', '24 + 28 + 32'],
        28: ['24 + 28 + 32'],
        32: ['24 + 28 + 32', '32 + 36 + 40 + 44'],
        36: ['32 + 36 + 40 + 44'],
        40: ['32 + 36 + 40 + 44'],
        44: ['32 + 36 + 40 + 44'],
      },
    },
  },

  [CrusherTypes.CH660]: {
    concaves: {
      EC: {
        18: ['18 + 20 + 24 + 28'],
        20: ['18 + 20 + 24 + 28'],
        24: ['18 + 20 + 24 + 28'],
        28: ['18 + 20 + 24 + 28', '28 + 32 + 36 + 40'],
        32: ['28 + 32 + 36 + 40'],
        36: ['28 + 32 + 36 + 40'],
        40: ['28 + 32 + 36 + 40', '40 + 44 + 48'],
        44: ['40 + 44 + 48'],
        48: ['40 + 44 + 48'],
      },
      CX: {
        18: ['18 + 20 + 24 + 28'],
        20: ['18 + 20 + 24 + 28'],
        24: ['18 + 20 + 24 + 28'],
        28: ['18 + 20 + 24 + 28', '28 + 32 + 36 + 40'],
        32: ['28 + 32 + 36 + 40'],
        36: ['28 + 32 + 36 + 40'],
        40: ['28 + 32 + 36 + 40', '40 + 44 + 48'],
        44: ['40 + 44 + 48'],
        48: ['40 + 44 + 48'],
      },
      C: {
        18: ['18 + 20 + 24 + 28'],
        20: ['18 + 20 + 24 + 28'],
        24: ['18 + 20 + 24 + 28'],
        28: ['18 + 20 + 24 + 28', '28 + 32 + 36 + 40'],
        32: ['28 + 32 + 36 + 40'],
        36: ['28 + 32 + 36 + 40'],
        40: ['28 + 32 + 36 + 40', '40 + 44 + 48'],
        44: ['40 + 44 + 48'],
        48: ['40 + 44 + 48'],
      },
      MC: {
        18: ['18 + 20 + 24 + 28'],
        20: ['18 + 20 + 24 + 28'],
        24: ['18 + 20 + 24 + 28'],
        28: ['18 + 20 + 24 + 28', '28 + 32 + 36 + 40'],
        32: ['28 + 32 + 36 + 40'],
        36: ['28 + 32 + 36 + 40'],
        40: ['28 + 32 + 36 + 40', '40 + 44 + 48'],
        44: ['40 + 44 + 48'],
        48: ['40 + 44 + 48'],
      },
      M: {
        18: ['18 + 20 + 24 + 28'],
        20: ['18 + 20 + 24 + 28'],
        24: ['18 + 20 + 24 + 28'],
        28: ['18 + 20 + 24 + 28', '28 + 32 + 36 + 40'],
        32: ['28 + 32 + 36 + 40'],
        36: ['28 + 32 + 36 + 40'],
        40: ['28 + 32 + 36 + 40', '40 + 44 + 48 + 50'],
        44: ['40 + 44 + 48 + 50'],
        48: ['40 + 44 + 48 + 50'],
      },
      MF: {
        18: ['18 + 20 + 24 + 28'],
        20: ['18 + 20 + 24 + 28'],
        24: ['18 + 20 + 24 + 28'],
        28: ['18 + 20 + 24 + 28', '28 + 32 + 36 + 40'],
        32: ['28 + 32 + 36 + 40'],
        36: ['28 + 32 + 36 + 40'],
        40: ['28 + 32 + 36 + 40', '40 + 44 + 48 + 50'],
        44: ['40 + 44 + 48 + 50'],
        48: ['40 + 44 + 48 + 50'],
      },
      F: {
        18: ['18 + 20 + 24 + 28'],
        20: ['18 + 20 + 24 + 28'],
        24: ['18 + 20 + 24 + 28'],
        28: ['18 + 20 + 24 + 28', '28 + 32 + 36 + 40'],
        32: ['28 + 32 + 36 + 40'],
        36: ['28 + 32 + 36 + 40'],
        40: ['28 + 32 + 36 + 40', '40 + 44 + 48 + 50'],
        44: ['40 + 44 + 48 + 50'],
        48: ['40 + 44 + 48 + 50'],
      },
      EF: {
        18: ['18 + 20 + 24 + 28'],
        20: ['18 + 20 + 24 + 28'],
        24: ['18 + 20 + 24 + 28'],
        28: ['18 + 20 + 24 + 28', '28 + 32 + 36 + 40'],
        32: ['28 + 32 + 36 + 40'],
        36: ['28 + 32 + 36 + 40'],
        40: ['28 + 32 + 36 + 40', '40 + 44 + 48 + 50'],
        44: ['40 + 44 + 48 + 50'],
        48: ['40 + 44 + 48 + 50'],
      },
      HR: {
        18: ['18 + 20 + 24 + 28'],
        20: ['18 + 20 + 24 + 28'],
        24: ['18 + 20 + 24 + 28'],
        28: ['18 + 20 + 24 + 28', '28 + 32 + 36 + 40'],
        32: ['28 + 32 + 36 + 40'],
        36: ['28 + 32 + 36 + 40'],
        40: ['28 + 32 + 36 + 40', '40 + 44 + 48 + 50'],
        44: ['40 + 44 + 48 + 50'],
        48: ['40 + 44 + 48 + 50'],
      },
    },
  },
  [CrusherTypes.CH662]: {
    concaves: {
      EC: {
        18: ['18 + 20 + 24 + 28'],
        20: ['18 + 20 + 24 + 28'],
        24: ['18 + 20 + 24 + 28'],
        28: ['18 + 20 + 24 + 28', '28 + 32 + 36 + 40'],
        32: ['28 + 32 + 36 + 40'],
        36: ['28 + 32 + 36 + 40'],
        40: ['28 + 32 + 36 + 40', '40 + 44 + 48'],
        44: ['40 + 44 + 48'],
        48: ['40 + 44 + 48'],
      },
      C: {
        18: ['18 + 20 + 24 + 28'],
        20: ['18 + 20 + 24 + 28'],
        24: ['18 + 20 + 24 + 28'],
        28: ['18 + 20 + 24 + 28', '28 + 32 + 36 + 40'],
        32: ['28 + 32 + 36 + 40'],
        36: ['28 + 32 + 36 + 40'],
        40: ['28 + 32 + 36 + 40', '40 + 44 + 48'],
        44: ['40 + 44 + 48'],
        48: ['40 + 44 + 48'],
      },
      MC: {
        18: ['18 + 20 + 24 + 28'],
        20: ['18 + 20 + 24 + 28'],
        24: ['18 + 20 + 24 + 28'],
        28: ['18 + 20 + 24 + 28', '28 + 32 + 36 + 40'],
        32: ['28 + 32 + 36 + 40'],
        36: ['28 + 32 + 36 + 40'],
        40: ['28 + 32 + 36 + 40', '40 + 44 + 48'],
        44: ['40 + 44 + 48'],
        48: ['40 + 44 + 48'],
      },
      M: {
        18: ['18 + 20 + 24 + 28'],
        20: ['18 + 20 + 24 + 28'],
        24: ['18 + 20 + 24 + 28'],
        28: ['18 + 20 + 24 + 28', '28 + 32 + 36 + 40'],
        32: ['28 + 32 + 36 + 40'],
        36: ['28 + 32 + 36 + 40'],
        40: ['28 + 32 + 36 + 40', '40 + 44 + 48 + 50'],
        44: ['40 + 44 + 48 + 50'],
        48: ['40 + 44 + 48 + 50'],
      },
      MF: {
        18: ['18 + 20 + 24 + 28'],
        20: ['18 + 20 + 24 + 28'],
        24: ['18 + 20 + 24 + 28'],
        28: ['18 + 20 + 24 + 28', '28 + 32 + 36 + 40'],
        32: ['28 + 32 + 36 + 40'],
        36: ['28 + 32 + 36 + 40'],
        40: ['28 + 32 + 36 + 40', '40 + 44 + 48 + 50'],
        44: ['40 + 44 + 48 + 50'],
        48: ['40 + 44 + 48 + 50'],
      },
      F: {
        18: ['18 + 20 + 24 + 28'],
        20: ['18 + 20 + 24 + 28'],
        24: ['18 + 20 + 24 + 28'],
        28: ['18 + 20 + 24 + 28', '28 + 32 + 36 + 40'],
        32: ['28 + 32 + 36 + 40'],
        36: ['28 + 32 + 36 + 40'],
        40: ['28 + 32 + 36 + 40', '40 + 44 + 48 + 50'],
        44: ['40 + 44 + 48 + 50'],
        48: ['40 + 44 + 48 + 50'],
      },
      EF: {
        18: ['18 + 20 + 24 + 28'],
        20: ['18 + 20 + 24 + 28'],
        24: ['18 + 20 + 24 + 28'],
        28: ['18 + 20 + 24 + 28', '28 + 32 + 36 + 40'],
        32: ['28 + 32 + 36 + 40'],
        36: ['28 + 32 + 36 + 40'],
        40: ['28 + 32 + 36 + 40', '40 + 44 + 48 + 50'],
        44: ['40 + 44 + 48 + 50'],
        48: ['40 + 44 + 48 + 50'],
      },
    },
  },
  [CrusherTypes.CH830i]: {
    concaves: {
      Other: {
        24: ['24 + 28 + 32'],
        28: ['24 + 28 + 32'],
        32: ['24 + 28 + 32', '32 + 36 + 40 + 44'],
        36: ['32 + 36 + 40 + 44'],
        40: ['32 + 36 + 40 + 44'],
        44: ['32 + 36 + 40 + 44', '44 + 48 + 52'],
        48: ['44 + 48 + 52'],
        52: ['44 + 48 + 52'],
      },
    },
  },
  [CrusherTypes.CH840i]: {
    concaves: {
      Other: {
        28: ['28 + 32 + 36'],
        32: ['28 + 32 + 36'],
        36: ['28 + 32 + 36', '36 + 40 + 44'],
        40: ['36 + 40 + 44'],
        44: ['36 + 40 + 44', '44 + 48 + 52'],
        48: ['44 + 48 + 52'],
        52: ['44 + 48 + 52'],
      },
    },
  },

  [CrusherTypes.CH870i]: {
    concaves: {
      Other: {
        32: ['32 + 37 + 42 + 47'],
        37: ['32 + 37 + 42 + 47'],
        42: ['32 + 37 + 42 + 47'],
        47: ['32 + 37 + 42 + 47', '47 + 52 + 57 + 62'],
        52: ['47 + 52 + 57 + 62'],
        57: ['47 + 52 + 57 + 62'],
        62: ['62 + 68 + 74 + 80', '47 + 52 + 57 + 62'],
        68: ['62 + 68 + 74 + 80'],
        74: ['62 + 68 + 74 + 80'],
        80: ['62 + 68 + 74 + 80'],
      },
    },
  },

  [CrusherTypes.CH890i]: {
    concaves: {
      Other: {
        24: ['24 + 28 + 32 + 36'],
        28: ['24 + 28 + 32 + 36'],
        32: ['24 + 28 + 32 + 36'],
        36: ['24 + 28 + 32 + 36', '36 + 40 + 44 + 48'],
        40: ['36 + 40 + 44 + 48'],
        44: ['36 + 40 + 44 + 48'],
        48: ['48 + 52 + 56 + 60', '36 + 40 + 44 + 48'],
        52: ['48 + 52 + 56 + 60'],
        56: ['48 + 52 + 56 + 60'],
        60: ['48 + 52 + 56 + 60', '60 + 64 + 68 + 70'],
        64: ['60 + 64 + 68 + 70'],
        68: ['60 + 64 + 68 + 70'],
        70: ['60 + 64 + 68 + 70'],
      },
    },
  },

  [CrusherTypes.CH895i]: {
    concaves: {
      Other: {
        24: ['24 + 28 + 32 + 36'],
        28: ['24 + 28 + 32 + 36'],
        32: ['24 + 28 + 32 + 36'],
        36: ['24 + 28 + 32 + 36', '36 + 40 + 44 + 48'],
        40: ['36 + 40 + 44 + 48'],
        44: ['36 + 40 + 44 + 48'],
        48: ['48 + 52 + 56 + 60', '36 + 40 + 44 + 48'],
        52: ['48 + 52 + 56 + 60'],
        56: ['48 + 52 + 56 + 60'],
        60: ['48 + 52 + 56 + 60', '60 + 64 + 68 + 70'],
        64: ['60 + 64 + 68 + 70'],
        68: ['60 + 64 + 68 + 70'],
        70: ['60 + 64 + 68 + 70'],
      },
    },
  },

  [CrusherTypes.CH860i]: {
    concaves: {
      Other: {
        30: ['30 + 34 + 38 + 42'],
        34: ['30 + 34 + 38 + 42'],
        38: ['30 + 34 + 38 + 42'],
        42: ['42 + 46 + 50 + 54 + 58', '30 + 34 + 38 + 42'],
        46: ['42 + 46 + 50 + 54 + 58'],
        50: ['42 + 46 + 50 + 54 + 58'],
        54: ['42 + 46 + 50 + 54 + 58'],
        58: ['58 + 62 + 66 + 70', '42 + 46 + 50 + 54 + 58'],
        62: ['58 + 62 + 66 + 70'],
        66: ['58 + 62 + 66 + 70'],
        70: ['58 + 62 + 66 + 70'],
      },
    },
  },

  [CrusherTypes.CH865i]: {
    concaves: {
      Other: {
        30: ['30 + 34 + 38 + 42'],
        34: ['30 + 34 + 38 + 42'],
        38: ['30 + 34 + 38 + 42'],
        42: ['42 + 46 + 50 + 54 + 58', '30 + 34 + 38 + 42'],
        46: ['42 + 46 + 50 + 54 + 58'],
        50: ['42 + 46 + 50 + 54 + 58'],
        54: ['42 + 46 + 50 + 54 + 58'],
        58: ['58 + 62 + 66 + 70', '42 + 46 + 50 + 54 + 58'],
        62: ['58 + 62 + 66 + 70'],
        66: ['58 + 62 + 66 + 70'],
        70: ['58 + 62 + 66 + 70'],
      },
    },
  },
};
